import React from 'react';
import { LevelUpRepository } from '../../repository';

class LevelUpHome extends React.Component {
  constructor(props) {
    super(props);

    this.repository = new LevelUpRepository();
    this.state = {
      userDetail: {}
    };
  }

  componentDidMount() {
    this.repository.findUserDetail((d) => {
      console.log(d);
    });
  }

  onSubmitUserCreate(e) {
    e.preventDefault();
    const formData = {
      username: e.target.username.value,
      nickname: e.target.nickname.value
    };
    this.repository.createUser(formData, (d) => {
      window.Toast.info("ok");
    });
  }

  render() {
    return (
      <div>
        <div>
          <form id={"user-create-form"} onSubmit={this.onSubmitUserCreate.bind(this)}>
            <input name={"username"} autoComplete={"off"} /><br />
            <input name={"nickname"} autoComplete={"off"} /><br />
            <input type={"submit"} value={"create"} />
          </form>
        </div>
        <br />

        <div style={{ textAlign: "center" }}>
          <div style={{ display: "inline-block", width: 800, height: 600, background: "#eee" }}>

          </div>
        </div>

      </div>
    );
  }
}

export { LevelUpHome };
